import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location){
  return originalReplace.call(this , location).catch(err=>err)
}
// 权限路由
export const permissionRouter = [{
  path: '/StandardManagement',
  name: '标准项目',
  component: () => import('../views/StandardManagement/index.vue'),
  // component: () => import('../views/content/index.vue'),
},{
  path: '/IndustryStandard',
  name: '行业标准',
  component: () => import('../views/StandardManagement/index.vue'),
},{
  path: '/courseDevelopment',
  name: '课程建设',
  component: () => import('../views/StandardManagement/index.vue'),
},{
  path: '/published',
  name: '已发布标准',
  component: () => import('../views/StandardManagement/published.vue'),
},{
  path: '/RoleManage',
  name: '用户管理',
  component: () => import('../views/RoleManage/index.vue')
},{
  path: '/Account',
  name: '公告管理',
  component: () => import('../views/Account/index.vue')
},{
  path: '/MenuManagement',
  name: '菜单管理',
  component: () => import('../views/menu/index.vue')
},{
  path: '/fileManagement',
  name: '文件管理',  
  component: () => import('../views/officeWork/standard.vue'),
},{
  path: '/standard',
  name: 'DISA标准',  
  component: () => import('../views/officeWork/standard.vue'),
},
{
  path: '/standard2',
  name: '其他标准',  
  component: () => import('../views/officeWork/standard.vue'),
},
{
  path: '/standard3',
  name: '课程文件',  
  component: () => import('../views/officeWork/standard.vue'),
},
{
  path: '/shareFiles',
  name: '共享文件',  
  component: () => import('../views/officeWork/fileManagement.vue'),
},{
  path: '/role',
  name: '角色管理',
  component: () => import('../views/role/index.vue')
},{
  path: '/tenant',
  name: '角色管理',
  component: () => import('../views/tenant/index.vue')
},{
  path: '/OperationLog',
  name: '操作日志',
  component: () => import('../views/operlog/index.vue')
},{
  path: '/loginLog',
  name: '登录日志',
  component: () => import('../views/logininfor/index.vue')
},{
  path: '/document-resource',
  name: '专家资源池',
  component: () => import('../views/Management/expert-resource.vue'),
},{
  path: '/document-document',
  name: '专家顾问管理',
  component: () => import('../views/Management/expert-document.vue'),
},
{
  path: '/vip-activity',
  name: '会员活动',
  component: () => import('../views/vip/activity.vue'),
},
{
  path: '/vip-third',
  name: '第三方活动',
  component: () => import('../views/vip/third.vue'),
},
{
  path: '/vip-enterprises',
  name: '会员企业',
  component: () => import('../views/vip/list.vue'),
},
{
  path: '/vip-examine',
  name: '会员审核',
  component: () => import('../views/vip/list2.vue'),
},
{
  path: '/styleClass',
  name: '会员审核',
  component: () => import('../views/styleClass/index.vue'),
},
// {
//   path: '/standard-text',
//   name: '规范列表',
//   component: () => import('../views/standard/index.vue'),
// },
{
  path: '/shimo',
  name: '石墨文档',
  component: () => import('../views/shimo/index.vue')
},
{
  path: '/self-check-info-manage',
  name: '规范检查管理',
  component: () => import('../views/selfCheck/index.vue')
},
{
  path: '/term-manage',
  name: '术语库管理',
  component: () => import('../views/term/index.vue')
},
{
  path: '/term-search',
  name: '术语库查询',
  component: () => import('../views/term/search.vue')
}
]
// 公共路由
const routes = [
  {
    path: '/',
    name: '登录',
    component: () => import('../views/Login/index.vue')
  },
  {
    path: '/login-member',
    name: '企业登录',
    component: () => import('../views/Login/login_vip.vue')
  },
  {
    path: '/web-member',
    name: '专家查询',
    component: () => import('../views/web-dome/index.vue')
  },
  {
    path: '/register-member',
    name: '企业注册',
    component: () => import('../views/register/index.vue')
  },
  {
    path: '/Home',
    name: 'Home',
    component: () => import('../views/Home/index.vue'),
    children:[{
      path: '/Main',
      name: '首页',
      component: () => import('../views/Main/index.vue')
    },{
      path: '/vip-apply',
      name: '入会申请',
      // component: () => import('../views/vip/apply.vue'),
      component: () => import('../views/vipApply/apply.vue'),
    },{
      path: '/vip-pool',
      name: '会员池',
      component: () => import('../views/vip/pool.vue'),
    },
   {
      path: '/enterpriseTechnologyGroup',
      name: '技术领域',
      component: () => import('../views/technology/enterprise-group.vue'),
    },{
      path: '/technicalTeamManagement',
      name: '技术领域',
      component: () => import('../views/technology/technical-management.vue'),
    },{
      path: '/classifyList',
      name: '项目计划',  
      component: () => import('../views/project/plan.vue'),
    },
    {
      path: '/info-list',
      name: '消息中心',
      component: () => import('../views/infoList/index.vue')
    },
    {
      path: '/details',
      name: '标准详情',
      component: () => import('../views/StandardManagement/details.vue')
    },{
      path: '/details_shed',
      name: '已发布标准详情',
      component: () => import('../views/StandardManagement/details_shed.vue')
    },{
      path: '/documen_details',
      name: '专家顾问详情',
      component: () => import('../views/Management/expert-details.vue'),
    },
    ...permissionRouter]
  },
  // 会员申请界面
  {
    path: '/vip-sigUp',
    name: 'vipApply',
    component: () => import('../views/vipApply/signUp.vue')
  },
  // office的页面
  {
    path: '/SeeOffice',
    name: 'SeeOffice',
    component: () => import('../views/officevVew/see.vue')
  },
  {
    path: '/SeeOfficeVip',
    name: 'SeeOffice',
    component: () => import('../views/officevVew/see_vip.vue')
  },
  {
    path: '/EditOffice',
    name: 'EditOffice',
    component: () => import('../views/officevVew/edit.vue')
  },
  {
    path: '/edit-doc',
    name: 'EditOffice',
    component: () => import('../views/officevVew/edit_doc.vue')
  },
  {
    path: '/see-doc',
    name: 'EditOffice',
    component: () => import('../views/officevVew/see_doc.vue')
  },
  {
    path: '/content-biaoge',
    name: 'content-biaoge',
    component: () => import('../views/content/index.vue')
  },
  {
    path: '/404',
    component: () => import('@/views/error/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error/401'),
    hidden: true
  },
]

const router = new VueRouter({
  routes,
  // 去掉 # 
  mode:'history',
})

export default router
